<div class="page center tiny" *ngIf="platformBrowser">
  <div class="page-inner">
    <div class="lock-icon">
      <app-svg size="2" src="/assets/icons/lock.svg"></app-svg>
    </div>
    <h1 class="gallery-title">Protected Gallery</h1>
    <h3 class="gallery-info">Please enter the password to continue.</h3>
    <form
      [formGroup]="form"
      #ngForm="ngForm"
      [class.submitted]="ngForm.submitted"
      class="form-container"
      (ngSubmit)="submit()"
    >
      <app-input-field [control]="form.controls.password" [big]="true">
        <input type="password" formControlName="password" appAutofocus autocomplete="password" />
        <label>Enter Password</label>
      </app-input-field>

      <button
        appButton
        name="confirm"
        location="gallery-password-page"
        color="primary"
        weight="bold"
        shape="round"
        height="4"
        size="3"
        spacing="full"
      >
        <span [class.hidden-text]="loading">Continue</span>
        <app-loading-indicator *ngIf="loading" color="white" size="small" class="button-loading-indicator">
        </app-loading-indicator>
      </button>

      <p class="legal small">
        If you don’t have the password, please reach out to the creator of this gallery to get access.
      </p>
    </form>
  </div>
</div>
<div class="page center tiny loading" *ngIf="!platformBrowser">
  <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
</div>
